import { useContext, useEffect, useRef, useState } from "react";
import "codemirror/lib/codemirror.css";
import "codemirror/mode/clike/clike";
import "codemirror/mode/javascript/javascript";
import "codemirror/mode/go/go";
import "codemirror/mode/python/python";
import "codemirror/theme/dracula.css";
import "codemirror/addon/edit/closetag";
import "codemirror/addon/edit/closebrackets";
import CodeMirror from "codemirror";

import ACTIONS from "./Actions";
import runContext from "../Context/RunContext";
import { toast } from "react-hot-toast";
import PrevDataContext from "../Context/PrevDataContext";
import LoadContext from "../Context/LoadContext";

const Editor = ({ socketRef, roomId, onCodeChange }) => {
  const editorRef = useRef(null);
  const {
    handleRun,
    inputValue,
    setInputValue,
    createFile,
    setOutputValue,
    runWithCodexApi,
  } = useContext(runContext);

  const {
    fileName,
    setFileName,
    getFile,
    prevData,
    saveButtonName,
    setSaveButtonName,
    updateFile,
    setPrevData,
  } = useContext(PrevDataContext);
  const modeObject = {
    java: "text/x-java",
    cpp: "text/x-c++src",
    c: "text/x-csrc",
    py: "python",
    js: "javascript",
    go:"go"
  };
  const [language, setLanguage] = useState("java");
  const [mode, setMode] = useState(modeObject[language]);
  console.log(mode)
  useEffect(() => {
    async function init() {
      editorRef.current = CodeMirror.fromTextArea(
        document.getElementById("textArea"),
        {
          mode: { name: `${mode}`, json: true },
          theme: "dracula",
          autoCloseBrackets: true,
          autoCloseTags: true,
          lineNumbers: true,
          indentUnit: 6,
          tabSize: 6,
        }
      );
      editorRef.current.on("change", async (instance, changes) => {
        const { origin } = changes;
        const code = instance.getValue();
        onCodeChange(code);
        setInputValue(code);
        if (origin !== "setValue") {
          socketRef.current.emit(ACTIONS.CODE_CHANGE, {
            roomId,
            code,
          });
        }
      });
    }
    init();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (socketRef.current)
      socketRef.current.on(ACTIONS.CODE_CHANGE, ({ code }) => {
        if (code !== null) {
          editorRef.current.setValue(code);
        }
      });
    // eslint-disable-next-line
  }, [socketRef.current]);

  useEffect(() => {
    async function setData() {
      const success = await getFile(roomId);
      if (success) {
        editorRef.current.setValue(prevData);
      } else {
        setPrevData("");
        setFileName("untitled");
        setSaveButtonName("Save");
        setOutputValue("");
      }
    }
    setData();
    // eslint-disable-next-line
  }, [prevData]);

  async function handleRunClick() {
    if (inputValue) {
      runWithCodexApi(language, inputValue); // with the CodeX api
      // handleRun(inputValue, "cpp"); // with our own api
    } else {
      toast.error("Code must not be empty");
    }
  }
  async function handleSave(e) {
    e.preventDefault();
    if (saveButtonName === "Save") {
      let success = await createFile(fileName, inputValue, roomId,mode);
      if (success) {
        setSaveButtonName("Update");
        toast.success("Saved successfully");
      } else {
        toast.error("something went's wrong");
      }
    } else {
      let success = await updateFile(roomId, fileName, inputValue,mode);
      if (success) {
        setSaveButtonName("Update");
        toast.success("Saved successfully");
      } else {
        toast.error("something went's wrong");
      }
    }
  }
  function handleLanguageChange(e) {
    e.preventDefault();
    setLanguage(e.target.value);
  }
  useEffect(()=>{
    setMode(modeObject[language])
  },[language])
  return (
    <div className="midEditor">
      <div className="filesOption">
        <div className="file">
          <input
            type="text"
            name="filename"
            value={fileName}
            onChange={(e) => setFileName(e.target.value)}
          />
        </div>
        <select
          value={language}
          onChange={handleLanguageChange}
          name="languages"
          id="lang"
        >
          <option value="js">JavaScript</option>
          <option value="java">Java</option>
          <option value="go">Golang</option>
          <option value="py">Python</option>
          <option value="c">C</option>
          <option value="cpp">C++</option>
        </select>
        <div className="run">
          <button onClick={handleRunClick}>
            <i className="fa-solid fa-2xl fa-caret-right"></i> Run
          </button>
        </div>
        <button className="savefile" onClick={handleSave}>
          {saveButtonName}
        </button>
      </div>
      <textarea id="textArea"></textarea>
    </div>
  );
};

export default Editor;
